enum SignatureTypeEnum {
  PART = 'part',
  WITNESS = 'witness',
}

export default SignatureTypeEnum;
